import React from "react";
import Hero from "./Hero";
import Menu from "./Menu";

const LandingPage = () => {
  return (
    <React.Fragment>
      <Hero></Hero>
      <Menu></Menu>
    </React.Fragment>
  );
};

export default LandingPage;
